module.exports = __webpack_public_path__ + "static/media/title_market.95b99311.svg";